import HeartRecommendation from '../../assets/gamePlan/heart.svg';
import LikeRecommendation from '../../assets/gamePlan/like-1.png';
import WhistleRecommendation from '../../assets/gamePlan/whistle-1.png';
import VectorOne from '../../assets/gamePlan/vector-1.svg';

// Action types data

export type GameplanProps = {
    gamePlan: any;
};

export const gamePlanColors = {
    recognize: '#2AA154',
    coach: '#FF9933',
    noData: '#00D6BB',
};

export const getActionColor = (actionId: number) => {
    switch (actionId) {
        case 2:
            return '#AE2727'; // Red
        case 3:
            return '#2AA154'; // Green
        default:
            return '#495057'; // Default gray
    }
};

export const actionStyles: Record<number, { color: string; icon: string }> = {
    1: { color: gamePlanColors.noData, icon: LikeRecommendation },
    2: { color: gamePlanColors.coach, icon: WhistleRecommendation },
    3: { color: gamePlanColors.recognize, icon: HeartRecommendation },
};

export const actionTypes = [
    {
        id: 'recognize',
        name: 'Recognize',
        bgColor: gamePlanColors.recognize,
        icon: HeartRecommendation,
        description: 'The Associate deserves recognition for the metric results.',
        vectorIcon: VectorOne,
    },
    {
        id: 'coach',
        name: 'Coach',
        bgColor: gamePlanColors.coach,
        icon: WhistleRecommendation,
        description: 'The Associate needs coaching on this metric.',
        vectorIcon: VectorOne,
    },
    {
        id: 'noData',
        name: 'No Data',
        bgColor: gamePlanColors.noData,
        icon: LikeRecommendation,
        description: 'There is no metric data available for the Associate.',
        vectorIcon: VectorOne,
    },
];

// Create action buttons data
export const createActions = [
    {
        id: 'strength',
        name: 'Strength',
        borderColor: '#7d71e2',
        textColor: 'var(--dark-purple)',
        description: 'Review Strengths related to this metric.',
    },
    {
        id: 'discussion',
        name: 'Discussion',
        borderColor: '#3299ff',
        textColor: 'var(--medium-blue)',
        description: 'Review discussions related to this metric.',
    },
    {
        id: 'metrics',
        name: 'Metrics',
        borderColor: '#00b6b2',
        textColor: 'var(--dark-teal)',
        description: 'Review data for this Metric.',
    },
    // {
    //     id: 'todo',
    //     name: 'To Do',
    //     borderColor: '#2aa154',
    //     textColor: 'var(--dark-green)',
    //     description: "Create To Do's.",
    // },
    {
        id: 'shoutOut',
        name: 'Shout Out',
        borderColor: '#f15523',
        textColor: 'var(--dark-orange)',
        description: 'Create Shout Outs',
    },
];
